@if (!isMobileWindow()) {
  <section id="wallet-action-buttons">
    <tradable-action-buttons [buttonActions]="getActionButtons()" [wallet]="wallet" [tradable]="tradable">
    </tradable-action-buttons>
  </section>
}
@if (isMobileWindow()) {
  <span class="mobile-actionbutton-main-bg"></span>
  <span
    class="mobile-actionbutton-main"
    [ngClass]="{ isVisible: isJoinedActionButtonClicked() }"
    (click)="mainButtonToggle()">
    <span class="mobile-actionbutton-main-icon">
      @if (isJoinedActionButtonClicked()) {
        <span class="bpi__icon-close"></span>
      }
      @if (!isJoinedActionButtonClicked()) {
        <span class="bpi__icon-trade"></span>
      }
    </span>
  </span>
  <div class="mobile-actionbutton-slate" [ngClass]="{ isVisible: isJoinedActionButtonClicked() }">
    <section id="wallet-action-buttons-mobile">
      <div class="mobile-actionbutton-title mod-trade">
        <span class="bpi__asset-{{ tradable?.getSymbol(true) }} mr-5"></span>
        {{ "actionbutton_mobile_header_trade" | translate: [tradable.getName()] }}
      </div>
      <tradable-action-buttons [buttonActions]="getActionButtons()" [wallet]="wallet" [tradable]="tradable">
      </tradable-action-buttons>
      <div class="mobile-actionbutton-custom-divider"></div>
      <div class="mobile-actionbutton-title mod-savings">
        {{ "actionbutton_mobile_header_savings" | translate }}
      </div>
      <div class="mobile-actionbutton-title mod-savings-description">
        {{ "actionbutton_mobile_description_savings" | translate }}
      </div>
      <div class="mobile-actionbutton-savings-button">
        <button
          class="btn btn-primary btn-savings-mobile"
          (click)="onActionClick('savings')"
          [disabled]="isActionButtonDisabled('savings')"
					[bp-tooltip]="
						getTooltip('savings')
							| translate
								: [
										amountForButton('savings')
											| fiat_precision_symbol
												: {
														id: fiat?.getId(),
														currencies: [fiat]
												  }
								  ]
					"
        position="top">
        {{ "add_new_savings_plan_mobile" | translate }}
      </button>
    </div>
  </section>
</div>
}
